import { render, staticRenderFns } from "./addNewUserDialog.vue?vue&type=template&id=30884dcb&scoped=true&"
import script from "./addNewUserDialog.vue?vue&type=script&lang=js&"
export * from "./addNewUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./addNewUserDialog.vue?vue&type=style&index=0&id=30884dcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30884dcb",
  null
  
)

export default component.exports